/**
 * Extend the Window interface to include the `fbq` property.
 * @typedef {typeof globalThis & { fbq?: (...args: any[]) => void }} CustomWindow
 */

/**
 * Send a Fb Pixel event.
 * This function assumes the FB base code is already loaded & initialized.
 * @param {string} id The pixel id.
 * @param {Array<any>} event The event array.
 */
export async function fbPixel(id, event) {
  const win = /** @type {CustomWindow} */ (window)
  if (typeof window !== 'undefined' && typeof win.fbq === 'function') {
    win.fbq('trackSingle', id, ...event)
  }
}
